import { render, staticRenderFns } from "./PAInsured.vue?vue&type=template&id=1274d716&"
import script from "./PAInsured.vue?vue&type=script&lang=js&"
export * from "./PAInsured.vue?vue&type=script&lang=js&"
import style0 from "./PAInsured.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAInsured.vue"
export default component.exports